import { Button, CssBaseline, Grid, Paper, Typography } from "@material-ui/core";
import { Form, Formik } from "formik";
//@ts-ignore
import MUIEditor from "react-mui-draft-wysiwyg";
import { useHistory } from "react-router-dom";
import LabelsContext from "../../../../lang/LabelsContext";
import Colors from "../../../../utils/Colors";
import { muiControls, parseDate, richTextStateToHtml } from "../../../../utils/Utils";
import { useStyles } from "../../tickets/TicketStyle";
import TicketEditCard from "./TicketEditCard";
import TicketEditService, { TicketEditServiceType } from "./TicketEditService";

export default function TicketEdit() {
  const classes = useStyles();
  const { Labels } = LabelsContext();
  const history = useHistory();

  const { ticket, editorState, setEditorState, sendTicketResponse }: TicketEditServiceType = TicketEditService();

  return (
    <>
      <CssBaseline />
      <div className={classes.layout}>
        <Paper className={classes.paper}>
          <Typography component="h1" variant="h4" align="center">
            {Labels.TICKET + " - " + ticket.name}
          </Typography>
          <Grid container xs={12} spacing={1}>
            <TicketEditCard
              name={ticket.user?.firstName + " " + ticket.user?.lastName}
              content={ticket.content}
              date={parseDate(ticket.date)}
              colorHeader={Colors.TICKET_GREEN_DARK}
              colorBody={Colors.TICKET_GREEN_LIGHT}
            />
          </Grid>
          {ticket.ticketResponses?.map((response: any) => {
            if (ticket.user.email === response.user.email) {
              return (
                <Grid container xs={12} spacing={1}>
                  <TicketEditCard
                    name={response.user.firstName + " " + response.user.lastName}
                    content={response.content}
                    date={parseDate(response.date)}
                    colorHeader={Colors.TICKET_GREEN_DARK}
                    colorBody={Colors.TICKET_GREEN_LIGHT}
                  />
                </Grid>
              );
            } else {
              return (
                <Grid container xs={12} justifyContent="flex-end" spacing={1}>
                  <TicketEditCard
                    name={response.user.firstName + " " + response.user.lastName}
                    content={response.content}
                    date={parseDate(response.date)}
                    colorHeader={Colors.TICKET_GRAY_DARK}
                    colorBody={Colors.TICKET_GRAY_LIGHT}
                  />
                </Grid>
              );
            }
          })}
          <Formik
            onSubmit={(values) => {
              sendTicketResponse(ticket.id, values);
            }}
            initialValues={{
              content: "",
            }}
          >
            {({ values, setFieldValue }) => (
              <Form>
                <Grid container spacing={1} className={classes.form}>
                  <Grid item xs={12} sm={12} spacing={1} className={classes.marginTop2}>
                    <MUIEditor
                      config={{
                        toolbar: {
                          controls: muiControls,
                        },
                        draftEditor: {
                          placeholder: Labels.PLACEHOLDER_WRITE_COMMENT,
                          stripPastedStyles: true,
                        },
                      }}
                      defaultValue={values.content}
                      editorState={editorState}
                      onChange={(state: any) => {
                        setEditorState(state);
                        setFieldValue("content", richTextStateToHtml(state));
                      }}
                    />
                  </Grid>
                  <Grid container xs={12} spacing={1} justifyContent="flex-end">
                    <Grid item>
                      <Button onClick={() => history.goBack()} variant="outlined" color="primary">
                        {Labels.BACK}
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button type="submit" variant="contained" color="primary">
                        {Labels.SEND}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Paper>
      </div>
    </>
  );
}
